var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogout = function SvgLogout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32 46.8H20.79c-.57 0-1.17.05-1.75 0-1.48-.15-2.46-1.43-2.52-2.88-.05-1.25 0-2.51 0-3.76V20.55c0-1.89 1.07-3.34 3.06-3.35 4.14-.03 8.28 0 12.41 0 .74 0 .75-2.4 0-2.4H20.02c-.91 0-1.76.01-2.54.56C16 16.39 15.5 18.3 15.46 20c-.02 1.13 0 2.25 0 3.38v15.58c0 3.21-.91 9.99 3.76 10.24 4.23.23 8.53 0 12.77 0 .74 0 .75-2.4 0-2.4ZM39.73 25.04l8 8v-2.07l-8 8c-.48.48-.18 2.78.53 2.07l8-8c.39-.39.39-1.68 0-2.07l-8-8c-.71-.71-1.02 1.59-.53 2.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 33.2h23.36c.74 0 .75-2.4 0-2.4H24c-.74 0-.75 2.4 0 2.4Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export default ForwardRef;